import type {} from '@redux-devtools/extension'; // required for devtools typing
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { TimesheetActionView } from '#/shared/types/TimesheetActionView';

export type TimesheetActionSelection = Exclude<TimesheetActionView, 'actions'>;

interface TimesheetActionViewStore {
  currentView: TimesheetActionView;
  lastSelectedAction: TimesheetActionSelection | null;
  setView: (view: TimesheetActionView) => void;
  reset: () => void;
}

export const useTimesheetActionViewStore = create<TimesheetActionViewStore>()(
  devtools(
    (set): TimesheetActionViewStore => ({
      currentView: 'actions',
      lastSelectedAction: null,
      setView: view => {
        set(
          {
            currentView: view,
            ...(view !== 'actions' && { lastSelectedAction: view }),
          },
          undefined,
          'setView',
        );
      },
      reset: () => {
        set({ currentView: 'actions', lastSelectedAction: null }, undefined, 'reset');
      },
    }),
    { name: 'timesheet-action-view-storage' },
  ),
);
